import React, { useState } from 'react'
import _ from 'lodash'

import AccommodationItem from './AccommodationItem'
import labels from '../../../configuration/labels'

import '../../../styles/scss/elements/accommodations-list.scss'

const HOTELS_PER_PAGE = 6

const AccommodationsList = ({ accommodations, className }) => {
  const [numberOfVisibleHotels, setNumberOfVisibleHotels] = useState(HOTELS_PER_PAGE)

  const displayLoadMoreButton = _.size(accommodations) > numberOfVisibleHotels
  const visibleAccommodations = _.slice(accommodations, 0, numberOfVisibleHotels)
  return (
    Boolean(_.size(accommodations)) && (
      <div className={`accommodations-list ${className}`}>
        <h3>{labels.accommodationOptionsHeader}</h3>
        <div className="accommodations-list__items">
          {_.map(visibleAccommodations, (accomm, key) => {
            const leonardoImages = _.map(_.get(accomm, 'viewExtensions.leonardoImages'))
            return(
              <AccommodationItem
                accommodation={accomm}
                key={key}
                name={accomm.name}
                image={
                  _.get(leonardoImages, '[0].url')
                  || _.get(accomm, 'images[0].path')
                  || _.get(accomm, 'viewExtensions.kaptioImages[0].path')
                  || _.get(accomm, 'defaultImage.path')
                }
              />
            )
          })}
        </div>
        {displayLoadMoreButton && (
          <button
            className="accommodations-list__load-more"
            onClick={() => setNumberOfVisibleHotels(value => value + HOTELS_PER_PAGE)}
          >
            Show More Hotels
          </button>
        )}
      </div>
    )
  )
}

export default AccommodationsList
